module.exports = __webpack_public_path__ + "img/solution-preevision-function-icon-4.74ad31da.svg";